/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./icon.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./icon.component";
var styles_IconComponent = [i0.styles];
var RenderType_IconComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_IconComponent, data: {} });
export { RenderType_IconComponent as RenderType_IconComponent };
export function View_IconComponent_0(_l) { return i1.ɵvid(2, [], null, null); }
export function View_IconComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-icon", [], [[8, "className", 0]], null, null, View_IconComponent_0, RenderType_IconComponent)), i1.ɵdid(1, 114688, null, 0, i2.IconComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, function (_ck, _v) { var currVal_0 = i1.ɵnov(_v, 1).classes; _ck(_v, 0, 0, currVal_0); }); }
var IconComponentNgFactory = i1.ɵccf("app-icon", i2.IconComponent, View_IconComponent_Host_0, { iconStyle: "iconStyle", iconType: "iconType", iconName: "iconName", spin: "spin" }, {}, []);
export { IconComponentNgFactory as IconComponentNgFactory };
